import React, { useEffect, useState } from "react";
import TotLayout from "./components/TotLayout";
import Round from "./round";
import TimeLeft from "./timeLeft";
import GuessSkipList from "./components/guessSkipList";
import FinalScore from "./components/finalScore";
import _ from "lodash";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as loaderAction from "../../redux/loader/action";
import { removeUser } from "../../components/shared/utils";
import skipBg from "../../assets/images/tot/skip-bg.png";
import scoreBg from "../../assets/images/tot/score-bg.png";
import Socket from "../../socket/socket";

let timerCountdown = null;
const TotGame = ({ gameReducer, paramsReducer, setIsLoading }) => {
  const [timer, setTimer] = useState(60);
  const [initialTime, setInitialTimer] = useState(60);
  const [showSkip, setSkip] = useState(false);
  const [showScore, setScore] = useState(false);
  const [prevSkipWords, setPrevSkipWords] = useState(0);
  const [prevScoreWords, setPrevScoreWords] = useState(0);
  const [prevStatus, setPrevStatus] = useState("");
  const [player_score, set_player_score] = useState([]);

  const screenParams = _.get(paramsReducer, "gameObj.screens", {});
  const roomObj = _.get(gameReducer, "roomObj") || {};
  const users = roomObj ? _.get(roomObj, "users") : [];
  const gameState = _.get(gameReducer, "roomObj.game_state");

  const gameDetails = _.get(gameState, "game_parameters");
  const status = _.get(gameState, "status") || "";
  const word = _.get(gameState, "word") || "";
  let totalRounds = _.get(gameDetails, "total_rounds");
  const activeGuesser = _.find(
    users,
    (el) =>
      el.player_id ===
      (gameState && gameState.active_player ? gameState.active_player : 0)
  );
  const currentRound = _.get(gameState, "current_round") || 1;
  const rightWords = _.get(gameState, "right_words") || [];
  const skippedWords = _.get(gameState, "skipped_words") || [];
  const scoreTrack = _.get(paramsReducer, "gameObj.tabletop_score_sound") || "";
  const skipTrack = _.get(paramsReducer, "gameObj.tabletop_skip_sound") || "";
  const defaultTrack =
    _.get(paramsReducer, "gameObj.tabletop_default_sound") || "";
  const tenSecTrack =
    _.get(paramsReducer, "gameObj.tabletop_ten_seconds_sound") || "";
  const right_words = _.get(gameState, "right_words");

  useEffect(() => {
    const score = [];
    users &&
      users.map((user) => {
        let count = 0;
        right_words.forEach((item) => {
          if (item.player_id === user.player_id) {
            count = count + 1;
          }
        });
        score.push({ ...user, score: count });
      });
    set_player_score(score);
  }, [right_words]);

  useEffect(() => {
    const time = _.get(gameDetails, "timer") || 60;
    playAudio(defaultTrack);
    setTimer(time);
    setInitialTimer(time);
    setPrevScoreWords(rightWords.length);
    setPrevSkipWords(skippedWords.length);
  }, []);

  useEffect(() => {
    const time = _.get(gameDetails, "timer") || 60;
    setTimer(time);
    setInitialTimer(time);
  }, [currentRound]);

  // useEffect(()=>{
  //   const time = _.get(gameDetails, "timer") || 60;
  //   setTimer(time);
  //   setInitialTimer(time);
  // },[users])


  // audio variables for TOT
  const audioTOT = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none"; //added to fix ios issue
    audio.autoplay = true; //avoid the user has not interacted with your page issue
    audio.onended = function () {
      audio.remove(); //remove after playing to clean the Dom
    };
    document.body.appendChild(audio);
  };

  const counts = () => {
    let sec = timer;
    timerCountdown = setInterval(() => {
      if (sec === 0) {
        clearInterval(timerCountdown);
      } else {
        sec = sec - 1;
        if (sec === 10) playAudio(tenSecTrack);
        setTimer(sec);
      }
    }, 1000);
  };
  

  useEffect(() => {
    if (skippedWords.length > prevSkipWords) {
      setSkip(true);
      playAudio(skipTrack);
      setTimeout(() => {
        setSkip(false);
      }, 1000);
      setPrevSkipWords(skippedWords.length);
    }
    if (rightWords.length > prevScoreWords) {
      setScore(true);
      playAudio(scoreTrack);
      setTimeout(() => {
        setScore(false);
      }, 1000);
      setPrevScoreWords(rightWords.length);
    }
  }, [skippedWords, rightWords]);

  useEffect(() => {
    const time = _.get(gameDetails, "timer") || 60;
    if (initialTime !== time) {
      setTimer(time);
      setInitialTimer(time);
      totalRounds = _.get(gameDetails, "total_rounds");
    }
  }, [gameDetails]);

  useEffect(() => {
    return Socket.addListener("update-status", async (res) => {
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    if (timer === 0) {
      const roomData = gameReducer.roomObj;
      let obj = {
        action: "update-status",
        roomId: roomData.id,
        // tableTopName: gameReducer.allGames[3].title,
        tableTopName:
          gameReducer?.gamesData?.onboarding?.step_3?.games[3]?.label,
      };

      setTimeout(() => {
        Socket.sendMessage(obj);
      }, 1500);
    }
  }, [timer]);

  useEffect(() => {
    if (status === "Guessing") {
      playAudio(defaultTrack);
      countdown();
      setPrevStatus(status);
    } else if (prevStatus === "PreGuess" && status === "Guessing") {
      playAudio(defaultTrack);
      countdown();
      setPrevStatus(status);
    } else if (prevStatus === "Guessing" && status === "ResultRound") {
      playAudio(defaultTrack);
      clearInterval(timerCountdown);
      setPrevStatus(status);
      setPrevScoreWords(0);
      setPrevSkipWords(0);
    } else if (prevStatus === "Guessing" && status === "PreGuess") {
      const time = _.get(gameDetails, "timer") || 60;
      setTimer(time);
      setInitialTimer(time);
      clearInterval(timerCountdown);
    } else {
      // playAudio(defaultTrack);
      setPrevStatus(status);
    }
  }, [status]);

  const playAudio = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none"; //added to fix ios issue
    audio.autoplay = true; //avoid the user has not interacted with your page issue
    audio.onended = function () {
      audio.remove(); //remove after playing to clean the Dom
    };
    document.body.appendChild(audio);
  };

  const countdown = () => {
    let sec = timer;
    timerCountdown = setInterval(() => {
      if (sec === 0) {
        clearInterval(timerCountdown);
      } else {
        sec = sec - 1;
        if (sec === 10) playAudio(tenSecTrack);
        setTimer(sec);
      }
    }, 1000);
  };
  

  function addFactor(e) {
    return `${e}`.length === 1 ? `0${e}` : e;
  }

  function getMinuteTime(time) {
    let divisor_for_minutes = time % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);
    let divisor_for_seconds = divisor_for_minutes % 60;
    let initialSec = Math.ceil(divisor_for_seconds);
    return {
      minutes,
      initialSec,
    };
  }

  function getSecondsTime(timeCount) {
    return timeCount.minutes * 60 + timeCount.initialSec;
  }

  const preguessComponent = () => {
    const timeCount = getMinuteTime(timer);
    // const secondsCount = getSecondsTime(timeCount);
    const t = (100 / initialTime) * timer;
    return (
      <Round
        users={users}
        activeGuesser={activeGuesser}
        screenParams={screenParams}
        count={t}
        time={`${addFactor(timeCount.minutes)}:${addFactor(
          timeCount.initialSec
        )}`}
      />
    );
  };

  const guessingComponent = () => {
    const guessSkipLabel =
      _.get(screenParams, "tot.guessing_skip_label") || "SKIP";
    const guessScoreLabel =
      _.get(screenParams, "tot.guessing_score_label") || "SCORE";
    const timeCount = getMinuteTime(timer);
    const t = (100 / initialTime) * timer;
    return (
      <>
        {!showScore && !showSkip && (
          <GuessSkipList
            screenParams={screenParams}
            roomObj={roomObj}
            activeGuesser={activeGuesser}
          />
        )}
        {showSkip && !showScore && (
          <div className="tot-50 pb-0 px-0">
            <div className="skip-card-bg tot-color-card h-100 ">
              {/* <p>{guessSkipLabel}</p> */}
              <img src={skipBg}></img>
            </div>
          </div>
        )}
        {showScore && !showSkip && (
          <div className="tot-50 pb-0 px-0">
            <div className="guess-card-bg tot-color-card h-100">
              {/* <p>{guessScoreLabel}</p> */}
              <img src={scoreBg}></img>
            </div>
          </div>
        )}
        <TimeLeft
          count={t}
          screenParams={screenParams}
          activeGuesser={activeGuesser}
          gameState={gameState}
          time={`${addFactor(timeCount.minutes)}:${addFactor(
            timeCount.initialSec
          )}`}
        />
      </>
    );
  };

  const resultRoundComponent = () => {
    return (
      <>
        <GuessSkipList
          screenParams={screenParams}
          roomObj={roomObj}
          activeGuesser={activeGuesser}
        />
        <FinalScore
          guesser={true}
          player_score={player_score}
          screenParams={screenParams}
          activeGuesser={activeGuesser}
          roomObj={roomObj}
          gameReducer={gameReducer}
        />
      </>
    );
  };

  const overComponent = () => {
    return (
      <>
        <GuessSkipList
          isGameOver={true}
          screenParams={screenParams}
          roomObj={roomObj}
          activeGuesser={activeGuesser}
        />
        <FinalScore
          roomObj={roomObj}
          guesser={false}
          screenParams={screenParams}
          gameReducer={gameReducer}
          activeGuesser={activeGuesser}
          player_score={player_score}
        />
      </>
    );
  };

  function getPageByStatus() {
    // return resultRoundComponent();

    // return resultRoundComponent();
    switch (status) {
      case "PreGuess":
        return preguessComponent();
      case "Guessing":
        return guessingComponent();
      case "ResultRound":
        return resultRoundComponent();
      case "Over":
        return overComponent();
      default:
        return null;
    }
  }

  const deletePlayer = (data) => {
    const roomObj = gameReducer.roomObj;
    removeUser(roomObj, data);
  };

  return <TotLayout deletePlayer={deletePlayer}>{getPageByStatus()}</TotLayout>;
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(TotGame);
